import {request} from './request';
const BASE = '/admin'
// 获取所属网点
export const getoutlets = (data) => {
    return request(`eos/getoutlets`,"post",data)
}
// 扫码获取条码信息
export const scan_barcode = (data) => {
    return request(`eos/barcode`,"post",data)
}